import { FunctionComponent } from 'react';

import HeroSlider from 'components/modules/public/layout/sections/HeroSlider';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutSectionHeroMobile: FunctionComponent<Props> = ({ background, underline, headline, subheadline, children }) => {
    return (
        <StyledComponent className='public-layout-section-hero-mobile'>
            <div>
                {background.mobile.map(element => (
                    <HeroSlider
                        key={element.id}
                        id={Number(element.id)}
                        background={element.href}
                        background1x={element.href1x}
                        background2x={element.href2x}
                        background3x={element.href3x}
                    />
                ))}
            </div>
            <div className="copy-container">
                <div className="copy">
                    {headline && (
                        <div className="headline-wrapper">
                            <h1
                                className="headline"
                                dangerouslySetInnerHTML={{ __html: headline }}
                                style={{
                                    backgroundImage: `url(${underline})`,
                                }}
                            />
                        </div>
                    )}
                    {subheadline && (
                        <div className="headline-wrapper">
                            <div
                                className="subheadline"
                                dangerouslySetInnerHTML={{ __html: subheadline }}
                                style={{
                                    backgroundImage: `url(${underline})`,
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
            {children && children}
        </StyledComponent>
    );
};

export default PublicLayoutSectionHeroMobile;